import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import styled from 'styled-components';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import { registerLocale } from 'react-datepicker';
import { sv } from 'date-fns/locale';
import '@aws-amplify/ui-react/styles.css';
import 'react-datepicker/dist/react-datepicker.css';
import './styles/datepicker-fix.css';

import { awsConfig } from './awsConfig';

import { NotificationProvider } from './context/notificationContext';
import GlobalStyle from './styles/globalStyle';
import PartnersPanel from './components/PartnersPanel';
import PartnerView from './views/partner/PartnerView';
import SearchView from './views/search/SearchView';
import LandingView from './views/LandingView/LandingView';
import PaymentsViews from './views/payments/PaymentsView';
import Notifications from './components/Notifications';
import TemplatesView from './views/templates/TemplatesView';
import AssignmentsView from './views/assignments/AssignmentsView';
import ReportsView from './views/reports/ReportsView';
import { OverlayProvider } from './context/overlayContext';
import { AlertProvider } from './context/alertContext';
import { SettingsProvider } from './context/settingsContext';
import { AssignmentsProvider } from './context/assignmentsContext';
import Overlay from './components/Overlay';
import Alert from './components/Alert';

// API calls go through the generated clients configured in lib/api-client.ts
// (imported by index.tsx); Amplify only handles Cognito here.
Amplify.configure(awsConfig);

registerLocale('sv', sv);

const LoginHeaderComponent = () => (
  <LoginHeader>
    <img
      src='https://images.squarespace-cdn.com/content/v1/5f6084124b9cf634f3a57d02/1600164389802-4N72NHPC9SL0FUKD6IX9/eir-logo-2.png?format=1500w'
      alt='Eir Admin'
    />
    <h1>Claims</h1>
  </LoginHeader>
);

const authenticatorComponents = {
  Header: LoginHeaderComponent,
};

const App = () => {
  return (
    <>
      <GlobalStyle />
      <Router basename='/ui'>
        <PageWrapper>
          <OverlayProvider>
            <AlertProvider>
              <NotificationProvider>
                <Alert />
                <Overlay />
                <Notifications />
                <Authenticator hideSignUp={true} components={authenticatorComponents}>
                  {({ signOut, user }) => (
                    <SettingsProvider>
                      <AssignmentsProvider>
                        <PartnersPanel onSignOut={signOut} />
                        <Routes>
                          <Route path='/' element={<LandingView />} />
                          <Route path='/payments' element={<PaymentsViews />} />
                          <Route path='/partner' element={<PartnerView />} />
                          <Route path='/search' element={<SearchView />} />
                          <Route
                            path='/templates'
                            element={<TemplatesView />}
                          />
                          <Route path='/assignments' element={<AssignmentsView />} />
                          <Route path='/reports' element={<ReportsView />} />
                        </Routes>
                      </AssignmentsProvider>
                    </SettingsProvider>
                  )}
                </Authenticator>
              </NotificationProvider>
            </AlertProvider>
          </OverlayProvider>
        </PageWrapper>
      </Router>
    </>
  );
};

export default App;

const PageWrapper = styled.div`
  display: flex;
`;

const LoginHeader = styled.header`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: center;
  margin-top: 3rem;

  img {
    width: 6rem;
    height: auto;
  }
`;
